import { theme } from "./theme/theme";
import { ChakraProvider } from "@chakra-ui/react";
import { AuthorizationGate } from "./providers/unleash/AuthorizationGate";
import FlagProvider from "@unleash/proxy-client-react";
import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "./api";
import { toastConfig } from "./configs/toastConfig";
import { unleashClient, SlowLoadingProvider } from "./providers";
import { resetUnfinishedLoginOnStartup } from "./utils/session/resetUnfinishedLoginOnStartup";

resetUnfinishedLoginOnStartup();

function App() {
  return (
    <ChakraProvider theme={theme} toastOptions={toastConfig}>
      <FlagProvider unleashClient={unleashClient}>
        <QueryClientProvider client={queryClient}>
          <SlowLoadingProvider />
          <AuthorizationGate />
        </QueryClientProvider>
      </FlagProvider>
    </ChakraProvider>
  );
}

export default App;
